export const collectionsMixins = {
  methods: {
    tagsCollection () {
      var vm = this
      this.$http.get('/tags')
        .then(function (response) {
          vm.tags_collection = response.data.tags.map(function (tag) {
            return {label: tag.name, value: tag.name, color: tag.color}
          })
        })
        .catch(e => { console.log(e.response) })
    },
    boardsCollection () {
      var vm = this
      this.$http.get('/boards')
        .then(function (response) {
          vm.boards_collection = response.data.map(function (board) {
            return {text: board.name, value: board.id}
          })
        })
        .catch(e => { console.log(e.response) })
    },
    ticketsCollection () {
      var vm = this
      this.$http.get('/tickets?collection=true')
        .then(function (response) {
          vm.tickets_collection = response.data.map(function (ticket) {
            return {text: '#' + ticket.id + ' - ' + ticket.name, value: ticket.id}
          })
        })
        .catch(e => { console.log(e) })
    },
    mailboxesCollection () {
      var vm = this
      this.$http.get('/mailboxes')
        .then(function (response) {
          vm.mailboxes_collection = response.data.map(function (mailbox) {
            return {label: mailbox.name, value: mailbox.id}
          })
        })
        .catch(e => { console.log(e.response) })
    },
    templateCollections (params) {
      var vm = this
      var urlParams
      if (params) {
        urlParams = params
      } else {
        urlParams = ''
      }
      var path = '/task_template_collections' + urlParams
      this.$http.get(path)
        .then(function (response) {
          vm.template_collections = response.data.map(function (collection) {
            return {label: collection.name, value: collection.id}
          })
        })
        .catch(e => { console.log(e.response) })
    },
    getTeams () {
      this.$http.get('/teams')
        .then(response => this.setTeams(response))
        .catch(e => { console.log(e.response) })
    },
    setTeams (response) {
      this.teams = response.data.map(function (team) {
        return {label: team.name, value: team.id}
      })
    },
    customersCollection () {
      var vm = this
      this.$http.get('/customers')
        .then(function (response) {
          vm.customerCollection = response.data.map(function (customer) {
            if (customer.name) {
              return {label: customer.email + ' - ' + customer.name, value: customer.email}
            } else {
              return {label: customer.email, value: customer.email}
            }
          })
        })
        .catch(e => { console.log(e.response) })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/collectionsMixins.js